import { createFileRoute } from "@tanstack/react-router";
import { SmsTemplatesPage } from "@/features/sms/templates-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/sms/szablony")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.sms.szablony", location.pathname);
	},
	component: SmsTemplatesPage,
});
